import { HOW_IT_WORK_GET_LIST,HOW_IT_WORK_GET_LIST_SUCCESS,HOW_IT_WORK_GET_LIST_ERROR } from "../../../redux/contants";

import { all, fork, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios'
import { apiBaseUrl } from '../../../constants/defaultValues';


function* fetchHowItWorksAPI() {
    // alert('saga')
    try {
        // const subscriberDetails = yield Axios.get(`Role/GetRoleList`).then(response => response.data);
        // alert("c")
          const config = {
            method: 'get',
            url: `${apiBaseUrl}HowItWork/GetHowItWorkList`,
            headers: { 
              'Accept': 'text/plain', 
              'Authorization': '<API Key>'
            }
          };
          const howitworkdetails = yield axios(config).then(response => response.data.Data);
        
        // console.log(subscriberDetails,"============")
        yield put({ type: HOW_IT_WORK_GET_LIST_SUCCESS, data: howitworkdetails });
    } catch (error) {
        yield put({ type: HOW_IT_WORK_GET_LIST_ERROR, error });
    }
}


export function* watchHowitWorks() {
    // eslint-disable-next-line no-use-before-define
    yield takeEvery(HOW_IT_WORK_GET_LIST, fetchHowItWorksAPI);

}

export default function* rootSaga() {
    yield all([
        fork(watchHowitWorks),
    ]);
}